export default __webpack_public_path__ + "static/media/4.e5de32e5.jpg";